document.addEventListener('DOMContentLoaded', (e) => initPackPdp({ evt: e }));
window.addEventListener('pageshow', (e) => initPackPdp({ evt: e }));

let packPdpInitialized = false;

function initPackPdp({ evt } = {}) {
  // Detect BFCache restore
  const isRestore =
    (evt && 'persisted' in evt && !!evt.persisted) ||
    (performance.getEntriesByType?.('navigation')?.[0]?.type === 'back_forward');

  // Idempotency guard: skip duplicate normal inits
  if (packPdpInitialized && !isRestore) return;
  packPdpInitialized = true;

  const bundleDataEl = document.querySelector('#bundle-data');
  if (!bundleDataEl) return;

  // Parse bundle payload from data-bundle
  let bundleData = [];
  try { bundleData = JSON.parse(bundleDataEl.dataset.bundle || '[]'); }
  catch (e) { console.warn('[Pack] Invalid bundle payload:', e); return; }

  const productElements = document.querySelectorAll('.pack-product');
  const finalPriceElements = document.querySelectorAll('.pack-price-final');
  const currentPriceElements = document.querySelectorAll('.pack-price-current');

  // --- NEW: helpers to set fresh _olbid after ATC ---
  function generateOlbid() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let out = '';
    for (let i = 0; i < 6; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
    return out;
  }

  function stampOlbid(bundleDataEl) {
    try {
      const data = JSON.parse(bundleDataEl.dataset.bundle || '[]');
      const token = generateOlbid();
      data.forEach(item => {
        if (item && item.properties) item.properties._olbid = token;
      });
      bundleDataEl.dataset.bundle = JSON.stringify(data);
      bundleData = data; // sync local reference
      // console.debug('[Pack] _olbid re-stamped after add:', token);
    } catch (e) {
      console.warn('[Pack] Failed to stamp _olbid:', e);
    }
  }

  function installPostAddHooks(bundleDataEl) {
    if (document.documentElement.dataset.packPostAddBound) return;
    document.documentElement.dataset.packPostAddBound = '1';

    const isCartAddURL = (u) => {
      try {
        const url = new URL(u, location.origin);
        return url.pathname === '/cart/add' || url.pathname === '/cart/add.js';
      } catch {
        return false;
      }
    };

    // Hook fetch
    if (window.fetch) {
      const _fetch = window.fetch.bind(window);
      window.fetch = async (...args) => {
        const res = await _fetch(...args);
        try {
          const req = args[0];
          const url = (typeof req === 'string') ? req : req?.url;
          const method = (args[1]?.method || (typeof req === 'object' && req?.method) || 'GET').toUpperCase();
          if (method === 'POST' && isCartAddURL(url) && res.ok) {
            queueMicrotask(() => stampOlbid(bundleDataEl));
          }
        } catch { }
        return res;
      };
    }

    // Hook XHR
    if (window.XMLHttpRequest) {
      const XHR = window.XMLHttpRequest;
      const _open = XHR.prototype.open;
      const _send = XHR.prototype.send;

      XHR.prototype.open = function (method, url, ...rest) {
        this.__pack_isAdd = (String(method || 'GET').toUpperCase() === 'POST') && isCartAddURL(url);
        return _open.call(this, method, url, ...rest);
      };
      XHR.prototype.send = function (...args) {
        if (this.__pack_isAdd) {
          this.addEventListener('load', () => {
            if (this.status >= 200 && this.status < 300) {
              stampOlbid(bundleDataEl);
            }
          });
        }
        return _send.apply(this, args);
      };
    }

    // Fallback: common theme events after add
    const postAddEvents = [
      'cart:updated',
      'ajaxProduct:added',
      'cart:line-item-added',
      'product:added'
    ];
    postAddEvents.forEach(evtName => {
      document.addEventListener(evtName, () => stampOlbid(bundleDataEl), { passive: true });
    });
  }

  // install hooks once
  installPostAddHooks(bundleDataEl);

  // Money formatter
  const formatMoney = (cents) => {
    const dollars = (cents / 100).toFixed(2);
    return dollars.endsWith('.00') ? `$${dollars.slice(0, -3)}` : `$${dollars}`;
  };

  // Render the final pack price (sum of each card's .pack-price-current)
  const updateFinalPackPrices = () => {
    let totalDollars = 0;
    currentPriceElements.forEach((el) => {
      const raw = (el.textContent || '').replace(/[$,]/g, '').trim();
      const n = parseFloat(raw);
      if (!Number.isNaN(n)) totalDollars += n;
    });
    const totalCents = Math.round(totalDollars * 100);
    const formattedPrice = formatMoney(totalCents);
    finalPriceElements.forEach((el) => {
      el.textContent = formattedPrice;
    });
  };

  // Helpers
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  const getPackDiscountPercent = () => {
    const fromAttr = Number(bundleDataEl.dataset.packDiscount);
    if (!Number.isNaN(fromAttr)) return clamp(fromAttr, 0, 100);

    const fromProps = Number(bundleData?.[0]?.properties?._olpd);
    if (!Number.isNaN(fromProps)) return clamp(fromProps, 0, 100);

    return 0;
  };

  const PACK_DISCOUNT = getPackDiscountPercent(); // i.e 25 = 25% off
  const discountMultiplier = Math.max(0, 1 - (PACK_DISCOUNT / 100));

  // Parse variants from data-variants='[...]'
  const parseVariants = (productEl) => {
    try {
      const variantsHost =
        productEl.dataset?.variants
          ? productEl
          : productEl.querySelector('[data-variants]');

      const raw = variantsHost?.dataset?.variants || '[]';
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : (Array.isArray(parsed.variants) ? parsed.variants : []);
    } catch (e) {
      console.warn('[Pack] Invalid variant data:', e);
      return [];
    }
  };

  const setUIToVariant = (productEl, optionCount, variant) => {
    for (let i = 0; i < optionCount; i++) {
      const expected = variant.options[i];
      const radios = productEl.querySelectorAll(`[data-option-index="${i}"] input[type="radio"]`);
      if (radios.length) {
        radios.forEach(r => { r.checked = false; });
        const matchRadio = Array.from(radios).find(r => r.value === expected) || radios[0];
        if (matchRadio) {
          matchRadio.checked = true;
          matchRadio.dispatchEvent(new Event('input', { bubbles: true }));
          matchRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        const select = productEl.querySelector(`[data-option-index="${i}"] select`);
        if (select) {
          const hasExpected = Array.from(select.options).some(o => o.value === expected);
          select.value = hasExpected ? expected : (select.options[0]?.value ?? '');
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  };

  const applyVariantToCard = (productEl, index, variant, selectedOptions) => {
    // Pack item image
    if (variant.featured_image && variant.featured_image.src) {
      const imgEl = productEl.querySelector(`.pack-product-image[data-pack-index="${index}"]`);
      if (imgEl) {
        imgEl.loading = 'lazy';
        const src = variant.featured_image.src;
        imgEl.src = `${src}&width=533`;
        imgEl.srcset = `
          ${src}&width=165 165w,
          ${src}&width=360 360w,
          ${src}&width=533 533w,
          ${src}&width=720 720w,
          ${src}&width=940 940w,
          ${src}&width=1066 1066w
        `;
      }
    }

    // Sync bundle payload for atc
    const bundleIndex = bundleData.findIndex(
      (entry) => entry.properties && entry.properties._bundleOrder === String(index + 1)
    );
    if (bundleIndex !== -1) {
      bundleData[bundleIndex].id = variant.id;
      bundleDataEl.dataset.bundle = JSON.stringify(bundleData);
    }

    // Discounted price display
    const priceEl = productEl.querySelector('.pack-price-current');
    const baseCents = Number(variant.price) || 0;
    const discountedCents = Math.round(baseCents * discountMultiplier);
    if (priceEl) priceEl.textContent = formatMoney(discountedCents);

    // Labels
    const colorEl = productEl.querySelector('.pack-item-color');
    const sizeEl = productEl.querySelector('.pack-item-size');
    const opts = Array.isArray(selectedOptions) && selectedOptions.length
      ? selectedOptions
      : (Array.isArray(variant.options) ? variant.options : []);
    if (colorEl && opts[0]) colorEl.textContent = opts[0];
    if (sizeEl && opts[1]) sizeEl.textContent = opts[1];

    updateFinalPackPrices();
  };

  const resolveSelectedVariant = (variants, productEl, optionCount) => {
    const selectedOptions = [];
    for (let i = 0; i < optionCount; i++) {
      const group = productEl.querySelectorAll(`[data-option-index="${i}"] input[type="radio"]`);
      const select = productEl.querySelector(`[data-option-index="${i}"] select`);
      let value = null;
      if (group.length) {
        const checked = Array.from(group).find((el) => el.checked);
        value = checked ? checked.value : null;
      } else if (select) {
        value = select.value;
      }
      selectedOptions.push(value);
    }
    const match = variants.find((v) => v.options.every((opt, i) => opt === selectedOptions[i]));
    return { match, selectedOptions };
  };

  const resetToFirstAvailableVariant = (productEl, index, variants) => {
    const optionCount = variants[0].options.length;
    const defaultVariant = variants.find(v => v.available) || variants[0];
    if (!defaultVariant) return;

    setUIToVariant(productEl, optionCount, defaultVariant);
    applyVariantToCard(productEl, index, defaultVariant, defaultVariant.options);
  };

  // Per card setup
  productElements.forEach((productEl, index) => {
    const variants = parseVariants(productEl);
    if (!variants.length || !variants[0].options) return;
    const optionCount = variants[0].options.length;

    if (!productEl.dataset.packBound) {
      productEl.dataset.packBound = '1';
      productEl.querySelectorAll('input[type="radio"], select').forEach((input) => {
        input.addEventListener('change', () => {
          const { match, selectedOptions } = resolveSelectedVariant(variants, productEl, optionCount);
          if (match) applyVariantToCard(productEl, index, match, selectedOptions);
        });
      });
    }

    resetToFirstAvailableVariant(productEl, index, variants);
    requestAnimationFrame(() => setTimeout(() => {
      resetToFirstAvailableVariant(productEl, index, variants);
    }, 0));
  });

  updateFinalPackPrices();

  // Extra reset only when restored from BFCache
  if (isRestore) {
    productElements.forEach((productEl, index) => {
      const variants = parseVariants(productEl);
      if (variants.length) resetToFirstAvailableVariant(productEl, index, variants);
    });
    updateFinalPackPrices();
  }
}
